import { useState } from 'react';
import { BUTTON_VARIANTS, Button, BUTTON_SIZES } from 'ui/button';
import { InputText } from 'ui/inputs';
import { MODAL_SIZES, ModalFooter, ModalHeader, MODAL_VARIANTS } from 'ui/modal';
import {
  TestMsgModals,
  useSendTestMsgContext,
} from 'modules/templateEditor/context/SendTestMsgContext';
import { useDisplayTestMessageStatus } from 'modules/templateEditor/hooks/useDisplayTestMessageStatus';
import { Body2 } from 'ui/theme';
import { displayContent } from 'modules/templateEditor/common';
import { StyledFormField, StyledModal, StyledModalBody } from '../SendTestMsgModals.styled';
import { cleanRecipients } from '../SendTestMsgToOtherModal/SendTestMsgToOther.utils';

export const DISPLAY_TEST_MESSAGE_MODAL_TEST_ID = 'display-test-message-modal';

export const DisplayTestMsgToOtherModal = () => {
  const [recipients, setRecipients] = useState('');
  const { onDisplayTestToOtherEmail, setOpenTestMsgModal } = useSendTestMsgContext();
  const { otherAddressesDisplaying } = useDisplayTestMessageStatus();
  const isDisplayingToOthers = !!otherAddressesDisplaying?.length;

  const handleCloseModal = () => {
    setOpenTestMsgModal(TestMsgModals.None);
  };

  const handleSubmit = (removing = false) => {
    if (removing) {
      onDisplayTestToOtherEmail(otherAddressesDisplaying, true);
    } else {
      onDisplayTestToOtherEmail(cleanRecipients(recipients), false);
    }
    handleCloseModal();
  };

  return (
    <StyledModal
      isModalOpen={true}
      onClose={handleCloseModal}
      id="displayTestMsgToOtherModal"
      data-test={DISPLAY_TEST_MESSAGE_MODAL_TEST_ID}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader autoFocus={false}>{displayContent.strDisplayTestToOtherTitle}</ModalHeader>
      <StyledModalBody>
        <Body2>{displayContent.strDisplayTestToOtherSubtitle}</Body2>
        <StyledFormField labelText="Recipient">
          <InputText
            value={isDisplayingToOthers ? otherAddressesDisplaying.join(', ') : recipients}
            onChange={setRecipients}
            placeholder={displayContent.placeholderRecipients}
            isReadOnly={isDisplayingToOthers}
          />
        </StyledFormField>
        {/* Hiding until proof system for eligibility is available with end dates */}
        {/* <StyledFormField labelText="Display stop date">
          <DatePickerWithCollapsibleCalendar date={moment(nextDay)} />
          <TypeaheadTimePicker time={moment(nextDay).format('hh:mm A') as TimeIn12HourClock} />
        </StyledFormField> */}
      </StyledModalBody>

      <ModalFooter hasCancel={false}>
        <Button
          variant={BUTTON_VARIANTS.GHOST}
          onClick={handleCloseModal}
          size={BUTTON_SIZES.LARGE}
        >
          {displayContent.btnCancel}
        </Button>
        {isDisplayingToOthers ? (
          <Button
            data-test="displayTestMsgStopBtn"
            onClick={() => handleSubmit(true)}
            variant={BUTTON_VARIANTS.SECONDARYDESTRUCTIVE}
            size={BUTTON_SIZES.LARGE}
          >
            {displayContent.btnClearTestMessage}
          </Button>
        ) : (
          <Button isDisabled={!recipients} onClick={() => handleSubmit()} size={BUTTON_SIZES.LARGE}>
            {displayContent.btnStartTestMessage}
          </Button>
        )}
      </ModalFooter>
    </StyledModal>
  );
};
